import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";

//------------- TYPES -------------------------

const ENVIAR_CORREO = "ENVIAR_CORREO";
const ENVIAR_CORREO_ERROR = "ENVIAR_CORREO_ERROR";
const ENVIAR_CORREO_SERVICE = "ENVIAR_CORREO_SERVICE";

const UPDATE_PASSWORD = "UPDATE_PASSWORD";
const UPDATE_PASSWORD_ERROR = "ENVIAR_CORREO_ERROR";
const UPDATE_PASSWORD_SERVICE = "ENVIAR_CORREO_SERVICE";

const CLEAN_STATE_CORREO = "CLEAN_STATE_CORREO";

//------------- STATE -------------------------

const datosIniciales = {
  /** Recueperar password por correo electrónico*/
  accessToken: null,
  contrasena: "",
  usuarioAspirante: null,
  usuario: null,
  cargandoInfo: null,
  msgEnvio: "",

  /**Actualizar password y envio a correo electrónico*/
  contrasenia: null,
  estatusAcceso: null,
};

//------------- REDUCER ------------------------
export default function correoReducer(state = datosIniciales, action) {
  switch (action.type) {
    case ENVIAR_CORREO:
      return {
        ...state,
        usuarioAspirante: action.payload.usuarioAspirante,
        contrasena: action.payload.contrasena,
        usuario: action.payload.usuario,
        msgEnvio: "envio",
      };
    case ENVIAR_CORREO_ERROR:
      return {
        ...state,
        msgEnvio: "envio error",
      };

    case ENVIAR_CORREO_SERVICE:
      return {
        ...state,
        msgEnvio: "envio service",
      };
    case UPDATE_PASSWORD:
      return {
        ...state,
        usuarioAspirante: action.payload.usuarioAspirante,
        usuario: action.payload.usuario,
        contrasenia: action.payload.contrasenia,
        accessToken: action.payload.accessToken,
        estatusAcceso: action.payload.estatusAcceso,
      };
    case UPDATE_PASSWORD_ERROR:
      return {
        ...state,
        contrasenia: "update password error",
      };

    case UPDATE_PASSWORD_SERVICE:
      return {
        ...state,
        contrasenia: "update password service",
      };
    case CLEAN_STATE_CORREO:
      return datosIniciales;

    default:
      return state;
  }
}

//------------- ACTIONS ------------------------

export const cleanCorreo = () => ({
  type: CLEAN_STATE_CORREO,
});

export const enviarCorreo = (data) => async (dispatch, getState) => {
  // let data = JSON.stringify({
  //   usuario: usuario,
  //   contrasena: contrasena,
  // });

  const { accessToken } = getState().usuarioLogin;

  try {
    const urls = await axios(window.location.origin + JSON_URL);

    const response = await axios({
      method: "POST",
      url: urls.data.urlServer + urls.data.urlCorreoPassword,
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    dispatch({
      type: ENVIAR_CORREO,
      payload: JSON.parse(JSON.stringify(response.data)),
    });
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: ENVIAR_CORREO_SERVICE,
      });
    } else {
      dispatch({
        type: ENVIAR_CORREO_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const updatePassword = (data) => async (dispatch, getState) => {
  // let data = {
  //   usuario: usuario,
  //   contrasenia: contrasenia,
  // };
  const { accessToken } = getState().usuarioLogin;

  try {
    const urls = await axios(window.location.origin + JSON_URL);

    const response = await axios({
      method: "POST",
      url: urls.data.urlServer + urls.data.urlUpdatePassword,
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    dispatch({
      type: UPDATE_PASSWORD,
      payload: JSON.parse(JSON.stringify(response.data)),
    });
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: UPDATE_PASSWORD_SERVICE,
      });
    } else {
      dispatch({
        type: UPDATE_PASSWORD_ERROR,
        payload: error.response.data,
      });
    }
  }
};
